import React from 'react';
import AddMenuLink from 'components/dashboard/menu-links-content/AddMenuLink';
import MenuLinkItemsList from 'components/dashboard/menu-links-content/MenuLinkList';

function MenuPageContent () {
  return (
    <div className="commerce-page-content__component">
      <AddMenuLink/> {/* button with input */}
      <MenuLinkItemsList/>
    </div>
  )
};

export default MenuPageContent;